var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemplateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 5.83335V17.5C16.6667 17.721 16.5789 17.933 16.4226 18.0893C16.2663 18.2456 16.0543 18.3334 15.8333 18.3334H4.16667C3.94565 18.3334 3.73369 18.2456 3.57741 18.0893C3.42113 17.933 3.33333 17.721 3.33333 17.5V2.50002C3.33333 2.27901 3.42113 2.06704 3.57741 1.91076C3.73369 1.75448 3.94565 1.66669 4.16667 1.66669H12.5M16.6667 5.83335H12.5V1.66669M16.6667 5.83335L12.5 1.66669M10 9.16669V15M7.5 9.16669H12.5",
    stroke: "#1C1D1F",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateIcon);
export default __webpack_public_path__ + "static/media/template_icon.0ff2526a25cf88ebd1436d5c1dee8c07.svg";
export { ForwardRef as ReactComponent };